import Modal from "../modal";
import Button from "../button";
import limitimagemodal from "../../assets/svg/warning.svg"

interface DeleteModalProps {
    isOpen: boolean;
    onClose: any;
    onSubmit: any;
    isLoading: boolean;
}

function DeleteModal({ isOpen, onClose, onSubmit, isLoading }: DeleteModalProps) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="sm" >
            <div className="text-center py-4">
                <img src={limitimagemodal} alt="" className="mx-auto mb-5" />
                <h2 className="text-2xl font-bold mb-3">Are you sure you want to delete this?</h2>
                <p className="text-sm font-normal text-labelTextCol mb-4 w-9/12 mx-auto">Once you delete this item you can’t recover it back, and have to recreate new</p>
                <div className="">
                    <Button
                        buttonText="No"
                        btnSize="lg"
                        btnIcon={false}
                        btnLabel
                        disabled={isLoading ? true : false}
                        btnColor="border-primary"
                        className="px-8 mr-2"
                        onClick={onClose}
                    />
                    <Button
                        buttonText="Yes"
                        btnSize="lg"
                        btnIcon={false}
                        btnLabel
                        disabled={isLoading ? true : false}
                        className="px-8 "
                        onClick={onSubmit}
                    />
                </div>
            </div>
        </Modal >
    );
};

export default DeleteModal;
